module.exports = __webpack_public_path__ + "img/APT.5197bcf8.png";